/*
 * @Author: liuYingBing
 * @Date: 2024-06-26 16:48:10
 * @LastEditors: liuYingBing
 * @LastEditTime: 2024-09-04 14:09:41
 * @FilePath: /fushigi/src/router/permission.ts
 * @Description:
 */
import router from '@/router'
import { token } from '@/utils'
import { PATH, CERT_STATUS_TYPE } from '@/enum'
import { Local } from '@/storage'
import { useUserStore } from '@/store'
import { storeToRefs } from 'pinia'
import useCertificateModal from '@/hooks/useCertificateModal'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
// import { AxiosCanceler } from '@/axios/cancel'
// const axiosCanceler = new AxiosCanceler()
// import { RouterLink, useRoute, useRouter } from 'vue-router'
// const router = useRouter()
const { showCertificate } = useCertificateModal()
// import dayjs from 'dayjs'
// import { FORMAT_DD } from '@/utils/tools'
// import { TOKEN } from '@/enum'
// import cookie from 'js-cookie'
// import { sendPoint } from '@/api/computer'

const certificate = (next: NavigationGuardNext, from: RouteLocationNormalized) => {
  const { certified, certStatus } = storeToRefs(useUserStore())
  if (certified.value && certStatus.value === CERT_STATUS_TYPE.SUCCEED) {
    next()
  } else {
    // 判断是否根据修改地址栏进行的跳转 是否非法修改直接跳转到首页
    if (from.path === '/') {
      next(PATH.GPU)
    } else {
      showCertificate()
    }
  }
}
// 路由守卫
router.beforeEach(
  async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
    // axiosCanceler.removeAllPending()
    const { isChild, permission } = storeToRefs(useUserStore())
    const RoutePathArr: string[] = []
    if (isChild.value) {
      const SubAccountRouteAuthorityMap = {
        createGPUInstance: [PATH.GPU, PATH.GPU_GENERIC],
        createImageAPP: [PATH.APPLY, PATH.GPU_APPLICATION],
        gpu: [PATH.GPU_GENERIC],
        app: [PATH.GPU_APPLICATION],
        openYunBucket: [PATH.DATA_DISK],
        image: [PATH.DATA_DISK],
        usingLLM: [
          PATH.MODEL_SQUARE,
          PATH.MODEL_EXPERIENCE,
          PATH.MODEL_STATS,
          PATH.MODEL_KEY,
          PATH.MODEL_IMAGE_GENERATOR,
          PATH.MODEL_VIDEO_GENERATOR,
        ],
      }
      // const keys = Object.keys(permission.value)
      const keys = Object.entries(permission.value)
        .filter((i) => {
          return i[1] === true
        })
        .map((i) => i[0])
      keys.forEach((i) => {
        if (SubAccountRouteAuthorityMap[i as keyof typeof SubAccountRouteAuthorityMap]) {
          RoutePathArr.push(
            ...SubAccountRouteAuthorityMap[i as keyof typeof SubAccountRouteAuthorityMap],
          )
        }
      })
      if (permission.value.createGPUInstance || permission.value.gpu) {
        RoutePathArr.push(PATH.IPVMDETAIL, PATH.RDP)
      }
    }
    const subAccountRouteAuthorityPath = [...new Set(RoutePathArr)]
    // 获取所有路由
    const allRoutes = router.getRoutes()
    allRoutes.forEach((item) => {
      subAccountRouteAuthorityPath.forEach((subItem) => {
        if (item.name === subItem) {
          item.meta.subAccountAuthority = true
        }
      })
    })
    // 每日登录领取算力
    // if (cookie.get(TOKEN) && Local.get('SEND_POINT') !== dayjs().format(FORMAT_DD)) {
    //   await sendPoint()
    //   Local.set('SEND_POINT', dayjs().format(FORMAT_DD))
    // }
    // 实名认证的的路由
    ;(window as any).toFullPath = to.fullPath
    // 如果如果有来源存取来源信息（销售）
    if (to.query.from) {
      // 销售来源
      Local.set('from', to.query.from)
    }

    // 未获取 token
    if (!token()) {
      if (to.query.token) {
        // 只读账号携带token进控制台页面
        next()
      } else if (to.meta?.requireAuth) {
        // 页面需要登录
        next(PATH.LOGIN)
      } else {
        next()
      }
    } else {
      //如果已经登录 注册，并准备进入 Login 页面，则重定向到主页
      if (to.path === PATH.LOGIN || to.path === PATH.REGISTER) {
        if (isChild.value && !to.meta?.subAccountAuthority) {
          if (permission.value.createGPUInstance) {
            next(PATH.GPU)
          } else if (!permission.value.createGPUInstance && permission.value.createImageAPP) {
            next(PATH.APPLY)
          } else if (!permission.value.createGPUInstance && !permission.value.createImageAPP) {
            if (permission.value.gpu) {
              next(PATH.GPU_GENERIC)
            }
            if (!permission.value.gpu && permission.value.app) {
              next(PATH.GPU_APPLICATION)
            }
          }
        } else {
          if (to.query?.redirect) {
            window.location.href = to.query?.redirect as string
            return
          }
          next(PATH.GPU)
        }
      } else {
        // 针对部分路由是否认证限制
        if (to.path === PATH.CREATE_DATA_SET) {
          certificate(next, from)
        } else {
          const nextRoute = allRoutes.filter((i) => {
            return i.name === to.name
          })[0]
          if (isChild.value && !nextRoute.meta?.subAccountAuthority) {
            if (permission.value.createGPUInstance) {
              next(PATH.GPU)
            } else if (!permission.value.createGPUInstance && permission.value.createImageAPP) {
              next(PATH.APPLY)
            } else if (!permission.value.createGPUInstance && !permission.value.createImageAPP) {
              if (permission.value.gpu) {
                next(PATH.GPU_GENERIC)
              }
              if (!permission.value.gpu && permission.value.app) {
                next(PATH.GPU_APPLICATION)
              }
            }
          } else {
            next()
          }
        }
      }
    }
  },
)

const errorMsg = 'Failed to fetch dynamically imported module:'
window.onunhandledrejection = (err: PromiseRejectionEvent) => {
  const msg = err?.reason?.message
  if (!msg) return

  if (err.reason.message.includes(errorMsg)) {
    window.location.href = (window as any).toFullPath
  }
}
